import {
    Injectable,
} from '@angular/core';

import {
    CanActivate,
} from '@angular/router';

import {
    Store,
} from '@ngxs/store';

import {
    Navigate,
} from '@ngxs/router-plugin';

import {
    RolesState,
} from '../store/roles/roles.state';


@Injectable({
    providedIn: 'root',
})
export class RoleGuard implements CanActivate {
    constructor(
        private _store: Store,
    ) { }

    public canActivate(): boolean {
        const roles = this._store.selectSnapshot(RolesState.selected);
        const hasRoles = (roles && roles.length > 0);

        if (!hasRoles) {
            this._store.dispatch(new Navigate(['/']));
        }

        return hasRoles;
    }
}
